import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';

export const ExternalOrderDetailsPublish = () => {
    return (
        <>
            <div className="content_wrap">
                <div className="fiter_top">
                    <h3 className="filter_heading">발주 상세보기</h3>
                    <div className="filter_toolbar">
                        <button className="btn btn-outline-primary w-100px h-38px"><img src={process.env.PUBLIC_URL + "/assets/images/icon_hamburger_btn.png"} alt="" />목록</button>
                        <button className="btn btn-secondary w-100px h-38px">수정</button>
                    </div>
                </div>
                <h5 className="subheading">발주 정보</h5>
                <div className="table_scroll mb-0">
                    <table className="table table-bordered my_table table_detail">
                        <tbody>
                            <tr>
                                <th style={{ width: "16.66%" }}>발송방법</th>
                                <td style={{ width: "33.34%" }}>1234_20240505_1</td>
                                <th style={{ width: "16.66%" }}>상태</th>
                                <td>발주</td>
                            </tr>
                            <tr>
                                <th>발송요청일</th>
                                <td>2024-05-05</td>
                                <th>수신자</th>
                                <td>김외부</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <Tabs
                defaultActiveKey="납품정보"
                transition={false}
                className="mytab_pills my-15px"
                variant="pills"
            >
                <Tab eventKey="납품정보" title="납품정보">
                    <div className="content_wrap">
                        <h5 className="subheading mt-0">발주정보</h5>
                        <div className="table_scroll mb-0">
                            <table className="table table-bordered my_table table_detail">
                                <tbody>
                                    <tr>
                                        <th style={{ width: "16.66%" }}>발주일자</th>
                                        <td style={{ width: "33.34%" }}>2024-05-09</td>
                                        <th style={{ width: "16.66%" }}>발주번호</th>
                                        <td>1234567869</td>
                                    </tr>
                                    <tr>
                                        <th>주문자</th>
                                        <td>홍길동 대리</td>
                                        <th>발주메모</th>
                                        <td>
                                            <input type="text" className="form-control" />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <h5 className="subheading">발주정보</h5>
                        <div className="table_scroll mb-0">
                            <table className="table table-bordered my_table table_detail">
                                <tbody>
                                    <tr>
                                        <th style={{ width: "16.66%" }}>발송요청일</th>
                                        <td style={{ width: "33.34%" }}>2024-05-09</td>
                                        <th style={{ width: "16.66%" }}>발송방법</th>
                                        <td>택배</td>
                                    </tr>
                                    <tr>
                                        <th>수신자</th>
                                        <td>홍길동 대리</td>
                                        <th>연락처</th>
                                        <td>010-1234-5678</td>
                                    </tr>
                                    <tr>
                                        <th>주소</th>
                                        <td colSpan={3}>경기도 성남시 분당구 000 000000</td>
                                    </tr>
                                    <tr>
                                        <th>송장번호</th>
                                        <td colSpan={3}></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <h5 className="subheading mt-20px">수금정보</h5>
                        <div className="table_scroll mb-0">
                            <table className="table table-bordered my_table table_detail">
                                <tbody>
                                    <tr>
                                        <th style={{ width: "16.66%" }}>수금예정일<span className="required">*</span></th>
                                        <td style={{ width: "33.34%" }}></td>
                                        <th style={{ width: "16.66%" }}>결제방법<span className="required">*</span></th>
                                        <td>현금</td>
                                    </tr>
                                    <tr>
                                        <th>수금메모(세금계산서 비고)</th>
                                        <td colSpan={3}></td>
                                    </tr>
                                    <tr>
                                        <th>계산서담당자</th>
                                        <td>김과장</td>
                                        <th>연락처</th>
                                        <td>010-1234-1234</td>
                                    </tr>
                                    <tr>
                                        <th>이메일</th>
                                        <td colSpan={3}>aaa@it.com</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </Tab>
                <Tab eventKey="품목정보" title="품목정보">
                    <div className="content_wrap">
                        <div class="table_top">
                            <h6 class="table_stats"></h6>
                            <div class="table_toolbar">
                                <button class="btn btn-outline-primary w-100px h-38px">목록​</button>
                                <button class="btn btn-secondary w-100px h-38px">수정</button>
                            </div>
                        </div>
                        <div className="table_scroll mb-0">
                            <table className="table table-bordered my_table table_detail">
                                <thead>
                                    <tr>
                                        <th style={{ width: "29.4%" }}>품목</th>
                                        <th style={{ width: "18.8%" }}>규격​</th>
                                        <th style={{ width: "10.5%" }}></th>
                                        <th style={{ width: "10.5%" }}></th>
                                        <th style={{ width: "16.4%" }}></th>
                                        <th>수량​</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>S1-Win10 IoT Ent 2021 LTSC MultiLang ESD OEI High End (PC) 🔍</td>
                                        <td className="text-center">MUT-00074​</td>
                                        <td className="text-center"></td>
                                        <td className="text-center"></td>
                                        <td className="text-center"></td>
                                        <td className="text-end">1</td>
                                    </tr>
                                    <tr>
                                        <td>Ex-001​</td>
                                        <td className="text-center"></td>
                                        <td className="text-center"></td>
                                        <td className="text-center"></td>
                                        <td className="text-center"></td>
                                        <td className="text-end">1</td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td className="text-start grey" colSpan={5}></td>
                                        <td className="text-end">2</td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                </Tab>

            </Tabs>

        </>
    );
}